import React from 'react';
import ReactDOM from 'react-dom';
import "primereact/resources/themes/lara-light-indigo/theme.css"; // podés cambiar de theme
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import './index.css';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
